import React, { useContext, useEffect, useState } from 'react'
import { apiGet } from '../../utils/apiFetch'
import apiPath from '../../utils/apiPath'
import OButton from 'components/reusable/OButton'
import ODateRangePicker from 'components/shared/datePicker/ODateRangePicker'
import dayjs from 'dayjs'
import AuthContext from 'context/AuthContext'
import { useTranslation } from 'react-i18next'
import BioMetricTable from './BioMetricTable'
import { FiDownload } from 'react-icons/fi'
import helpers from '../../utils/helpers'
import Select from 'react-select'
import useToastContext from 'hooks/useToastContext'

const BioMetricTrackModule = () => {
  const { updatePageName } = useContext(AuthContext)
  const notification = useToastContext()
  const { t } = useTranslation()
  const [employeeList, setEmployeeList] = useState([])
  const [currentItem, setCurrentItem] = useState('')
  const [isEmployeeList, setIsEmployeeList] = useState(false)
  const [searchTerm, setSearchTerm] = useState('')
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('')
  const [isInitialized, setIsInitialized] = useState(false)
  const [filterData, setFilterData] = useState({
    category: [],
    searchKey: '',
    startDate: '',
    userIds: '',
    endDate: '',
    isReset: false,
    isFilter: false
  })

  const handleView = item => {
    setCurrentItem(item)
    setIsEmployeeList(!isEmployeeList)
  }

  const allEmployeeList = async data => {
    try {
      const { category, startDate, endDate } = filterData
      let newData = []
      category?.map(depart => {
        newData.push(depart?.value)
      })
      var payload = {
        startDate: startDate ? dayjs(startDate).format('YYYY-MM-DD') : null,
        endDate: endDate ? dayjs(endDate).format('YYYY-MM-DD') : null
      }
      if (newData.length > 0) payload.employeeIDs = JSON.stringify(newData)
      var path = apiPath.timeSheetListHR
      const result = await apiGet(path, payload)
      var response = result?.data?.results
      const resultStatus = result?.data?.success
      if (resultStatus) {
        notification.success(result?.data.message)
        setEmployeeList(response?.docs)
      } else {
        if (newData.length > 0) {
          notification.error(result?.data.message)
        }
      }
    } catch (error) {
      console.log('error in get all employee list==>>>>', error.message)
    }
  }

  const handleDownload = async () => {
    try {
      const { category, startDate, endDate } = filterData
      let newData = []
      category?.map(depart => {
        newData.push(depart?.value)
      })
      var payload = {
        startDate: startDate ? dayjs(startDate).format('YYYY-MM-DD') : null,
        endDate: endDate ? dayjs(endDate).format('YYYY-MM-DD') : null
      }
      if (newData.length > 0) payload.employeeIDs = JSON.stringify(newData)
      const res = await apiGet(apiPath.downloadBiometricHR, payload)
      if (res.data.success) {
        helpers.downloadFile(res?.data?.results?.file_path)
      } else {
        notification.error(res?.data.message)
      }
    } catch (error) {
      console.log('error:', error)
    }
  }

  useEffect(() => {
    allEmployeeList()
  }, [filterData])

  const handleReset = () => {
    setFilterData({
      category: null,
      searchKey: '',
      startDate: '',
      endDate: '',
      userIds: '',
      isReset: true,
      isFilter: false
    })
    setEmployeeList([])
    setSearchTerm('')
  }

  const [finalEmployeeList, setFinalEmployeeList] = useState([])

  const hrEmployeeList = async () => {
    try {
      const result = await apiGet(apiPath.employeeListHR)
      if (result?.data?.success) {
        const data = result?.data?.results
        let newArray = []
        data?.map(item => {
          let obj = {}
          obj['label'] = item?.name
          obj['value'] = item?._id
          newArray.push(obj)
        })
        setFinalEmployeeList(newArray)
      }
    } catch (error) {}
  }

  const handleDateChange = (start, end) => {
    setFilterData({
      ...filterData,
      startDate: start,
      endDate: end,
      isFilter: true
    })
  }

  useEffect(() => {
    if (!isInitialized) {
      setIsInitialized(true)
    } else if (searchTerm || !filterData?.isReset) {
      setFilterData({
        ...filterData,
        isReset: false,
        searchKey: debouncedSearchTerm ? debouncedSearchTerm : '',
        isFilter: debouncedSearchTerm ? true : false
      })
    }
  }, [debouncedSearchTerm])

  const handleEmployee = item => {
    setFilterData({ ...filterData, category: item, isFilter: true })
  }

  const handleDeleteSuccess = () => {
    // Refresh the list after successful deletion
    allEmployeeList();
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm)
    }, 500)
    return () => {
      clearTimeout(timeoutId)
    }
  }, [searchTerm])

  useEffect(() => {
    updatePageName(t('BIOMETRIC_TRACK_MODULE'))
  }, [])

  useEffect(() => {
    hrEmployeeList()
  }, [])

  return (
    <>
      {' '}
      <div className='bg-[#F9F9F9]'>
        <div className='px-3 py-4'>
          <div className='bg-white border border-[#E9EDF9] rounded-lg'>
            <h2 className=' px-4 py-3'>
              <strong>
                Select Employee with start date & end Date to view biometric.
              </strong>
            </h2>
            <form className='border-b border-b-[#E3E3E3] 2xl:flex gap-2 px-4 py-3'>
              <div className='col-span-2 flex flex-wrap  items-center mb-2 2xl:mb-0'>
                <div className='flex items-center lg:pt-0 pt-3 flex-wrap '>
                  <Select
                    isMulti
                    styles={{
                      control: baseStyles => ({
                        ...baseStyles,
                        padding: '0px 4px',
                        borderRadius: '0.5rem',
                        border: '2px solid rgb(223 223 223);',
                        color: '#000',
                        width: '200px',
                        marginBlockEnd: '10px'
                      })
                    }}
                    name='category'
                    options={finalEmployeeList}
                    value={filterData.category || null}
                    placeholder={
                      <>
                        <span
                          style={{ fontSize: '0.875rem' }}
                          className='text-[#A5A5A5]'
                        >
                          {' '}
                          {t('ALL')}
                        </span>
                        <span className='px-1 text-red-500 '>*</span>
                      </>
                    }
                    className='basic-multi-select'
                    classNamePrefix='select'
                    onChange={item => {
                      handleEmployee(item)
                    }}
                  />
                  <ODateRangePicker
                    handleDateChange={handleDateChange}
                    isReset={filterData?.isReset}
                    setIsReset={setFilterData}
                  />
                  <OButton
                    label='Reset'
                    type='button'
                    onClick={handleReset}
                    extraClasses='ml-3 mb-3'
                    style={{ borderRadius: '0.5rem' }}
                  />
                </div>
              </div>
              <div className='flex items-center justify-end px-4 ms-auto mb-3'>
                <button
                  type='button'
                  title={t('EXPORT')}
                  className='bg-LightBlue flex text-sm px-8 ml-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-DarkBlue whitespace-nowrap'
                  onClick={e => handleDownload()}
                >
                  <FiDownload className='mr-3' />
                  {t('EXPORT')}
                </button>
              </div>
            </form>
            {employeeList?.length > 0 && (
              <BioMetricTable
                employeeList={employeeList}
                allEmployeeList={allEmployeeList}
                handleView={handleView}
                currentItem={currentItem}
                isEmployeeList={isEmployeeList}
                onDeleteSuccess={handleDeleteSuccess}
              />
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default BioMetricTrackModule
